module.exports = __webpack_public_path__ + "img/85.5.COD.b5d79116.png";